export type School = {
  id: string
  cn: string
  en: string
  country: string
  flag: string
  city: string
  rank: number
  tags: string[]
  logoBg: string
  logoText: string
  logoColor?: string
  photo: string
  offers: string
  hot?: boolean
}

export const schools: School[] = [
  {
    id: 'mit',
    cn: '麻省理工学院',
    en: 'Massachusetts Institute of Technology',
    country: '美国',
    flag: '🇺🇸',
    city: '马萨诸塞州',
    rank: 1,
    tags: ['爱国者联盟', '美国大学协会'],
    logoBg: '#ffffff',
    logoText: 'MIT',
    logoColor: '#A31F34',
    photo: 'https://images.unsplash.com/photo-1564981797816-1043664bf78d?w=800',
    offers: '850+',
    hot: true,
  },
  {
    id: 'imperial',
    cn: '帝国理工学院',
    en: 'Imperial College London',
    country: '英国',
    flag: '🇬🇧',
    city: '伦敦',
    rank: 2,
    tags: ['G5超级精英大学', '金三角名校'],
    logoBg: '#0c2c5f',
    logoText: 'Imperial',
    logoColor: '#ffffff',
    photo: 'https://images.unsplash.com/photo-1568116762-ffd5d8d3d24a?w=800',
    offers: '200+',
    hot: true,
  },
  {
    id: 'stanford',
    cn: '斯坦福大学',
    en: 'Stanford University',
    country: '美国',
    flag: '🇺🇸',
    city: '加利福尼亚州',
    rank: 3,
    tags: ['新常春藤', '美国大学协会'],
    logoBg: '#8C1515',
    logoText: 'S',
    logoColor: '#ffffff',
    photo: 'https://images.unsplash.com/photo-1607237138185-eedd9c632b0b?w=800',
    offers: '420+',
  },
  {
    id: 'oxford',
    cn: '牛津大学',
    en: 'University of Oxford',
    country: '英国',
    flag: '🇬🇧',
    city: '牛津',
    rank: 4,
    tags: ['罗素大学集团', '金三角名校'],
    logoBg: '#002147',
    logoText: 'Ox',
    logoColor: '#ffffff',
    photo: 'https://images.unsplash.com/photo-1583468982228-19f19164aee2?w=800',
    offers: '300+',
  },
  {
    id: 'harvard',
    cn: '哈佛大学',
    en: 'Harvard University',
    country: '美国',
    flag: '🇺🇸',
    city: '马萨诸塞州',
    rank: 5,
    tags: ['常春藤盟校', '美国大学协会'],
    logoBg: '#A51C30',
    logoText: 'H',
    logoColor: '#ffffff',
    photo: 'https://images.unsplash.com/photo-1559135197-8a45ea74d367?w=800',
    offers: '380+',
  },
  {
    id: 'cambridge',
    cn: '剑桥大学',
    en: 'University of Cambridge',
    country: '英国',
    flag: '🇬🇧',
    city: '剑桥',
    rank: 6,
    tags: ['罗素大学集团', '金三角名校'],
    logoBg: '#A3C1AD',
    logoText: 'Cam',
    logoColor: '#ffffff',
    photo: 'https://images.unsplash.com/photo-1526129318478-62ed807ebdf9?w=800',
    offers: '260+',
  },
  {
    id: 'nus',
    cn: '新加坡国立大学',
    en: 'National University of Singapore',
    country: '新加坡',
    flag: '🇸🇬',
    city: '新加坡',
    rank: 8,
    tags: ['亚洲顶尖', 'AAU'],
    logoBg: '#003D7C',
    logoText: 'NUS',
    logoColor: '#EF7C00',
    photo: 'https://images.unsplash.com/photo-1564503391787-1c9f5b66de7c?w=800',
    offers: '2600+',
    hot: true,
  },
  {
    id: 'ntu',
    cn: '南洋理工大学',
    en: 'Nanyang Technological University',
    country: '新加坡',
    flag: '🇸🇬',
    city: '新加坡',
    rank: 15,
    tags: ['亚洲顶尖'],
    logoBg: '#fff',
    logoText: 'NTU',
    logoColor: '#003B70',
    photo: 'https://images.unsplash.com/photo-1607237138185-eedd9c632b0b?w=800',
    offers: '1800+',
  },
  {
    id: 'hku',
    cn: '香港大学',
    en: 'The University of Hong Kong',
    country: '中国香港',
    flag: '🇭🇰',
    city: '香港',
    rank: 17,
    tags: ['港校三大', 'AAU'],
    logoBg: '#006338',
    logoText: 'HKU',
    logoColor: '#ffffff',
    photo: 'https://images.unsplash.com/photo-1576487236230-eaa4afe68192?w=800',
    offers: '1500+',
    hot: true,
  },
  {
    id: 'cuhk',
    cn: '香港中文大学',
    en: 'The Chinese University of Hong Kong',
    country: '中国香港',
    flag: '🇭🇰',
    city: '香港',
    rank: 36,
    tags: ['港校三大'],
    logoBg: '#7B003C',
    logoText: 'CUHK',
    logoColor: '#ffffff',
    photo: 'https://images.unsplash.com/photo-1592280771190-3e2e4d571952?w=800',
    offers: '1200+',
  },
  {
    id: 'cityu',
    cn: '香港城市大学',
    en: 'City University of Hong Kong',
    country: '中国香港',
    flag: '🇭🇰',
    city: '香港',
    rank: 62,
    tags: ['港校八大'],
    logoBg: '#C8102E',
    logoText: 'CityU',
    logoColor: '#ffffff',
    photo: 'https://images.unsplash.com/photo-1564503391787-1c9f5b66de7c?w=800',
    offers: '900+',
  },
  {
    id: 'manchester',
    cn: '曼彻斯特大学',
    en: 'The University of Manchester',
    country: '英国',
    flag: '🇬🇧',
    city: '曼彻斯特',
    rank: 34,
    tags: ['罗素大学集团', '红砖大学'],
    logoBg: '#660099',
    logoText: 'MAN',
    logoColor: '#ffffff',
    photo: 'https://images.unsplash.com/photo-1568116762-ffd5d8d3d24a?w=800',
    offers: '700+',
  },
  {
    id: 'ucl',
    cn: '伦敦大学学院',
    en: 'University College London',
    country: '英国',
    flag: '🇬🇧',
    city: '伦敦',
    rank: 9,
    tags: ['G5超级精英大学', '金三角名校'],
    logoBg: '#002147',
    logoText: 'UCL',
    logoColor: '#ffffff',
    photo: 'https://images.unsplash.com/photo-1568116762-ffd5d8d3d24a?w=800',
    offers: '700+',
  },
]
